import React from 'react';
import '../css/index.css'

import Navigation from './Navigation';
import Footer from './Footer';

export default function Contact() {
    return (
        <>
            <Navigation />
            <div class="contact-container">
                <table class="table">
                    <tr>
                        <td>
                            <span> Call Me on </span>
                        </td>
                        <td><a class="clickable" href="tel:+919777343366">+91 9777343366</a></td>
                    </tr>
                    <tr>
                        <td>
                            <span> WhatsApp Me on </span>
                        </td>
                        <td><a class="clickable" href="whatsapp://send?abid=+919777343366&text=Hi%2C%20Malaya!">+91 9777343366</a></td>
                    </tr>
                    <tr>
                        <td>
                            <span>Mail Me on </span>
                        </td>
                        <td><a class="clickable" href="mailto:malaya.manjula@gmail.com">malaya.manjula@gmail.com</a></td>
                    </tr>
                </table>
            </div>
            <div className='container'>
                <div className='form-container'>
                <form name="contact" method='post' action="/home" netlify>
                    <div className="button-container">
                        <span className="button outline">Fill the form, I'll get back to you soon.</span>
                    </div>
                    <div className='mt-5 d-flex'>
                        <span>Name</span>
                           
                            <input className='form-input outline' type="text" name="name" required />
                      
                    </div>
                    <div className='mt-5  d-flex'>
                          <span>Email</span>
                            <input className='form-input outline' type="email" name="email" required />
                        
                    </div>
                     <div className='mt-5  d-flex'>
                          <span>Mobile</span>
                            <input className='form-input outline' type="phone" name="Mobile No" required />
                        
                    </div>
                    <div className='mt-5  d-flex' >
                          <span>Message</span>
                            <textarea  className='form-input outline h-10' name="message" rows="5"></textarea>
                       
                    </div>
                    <button type="submit" className='button-transparent outline'>Send</button>
                </form>
                </div>
            </div>
            <Footer />
        </>
    );
}